module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/temp-dis-f3fb2e64b69263f5ac52af244b40c09b.png";